import React from 'react';
import { useButton } from '~Hooks';
import styled from '@emotion/styled';
import Heading from '~ComponentsImproved/Typography/Heading';
import { CourseType } from '.';

const Type = styled.div<{ color: string; touching?: boolean }>`
  background: ${({ color }) => color ?? 'var(--colorBlueGray200)'};
  width: 80px;
  height: 80px;
  margin: 8px;
  box-shadow: 0px 0px 16px 4px rgb(0 0 0 / 8%), 0px 1px 0px rgb(0 0 0 / 16%),
    0px 1px 3px rgb(0 0 0 / 16%);
  border-radius: 4px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  transform: ${({ touching }) => (touching ? 'scale(0.96)' : '1')};
`;

interface Props {
  courseType: CourseType;
  onChange: (value: CourseType) => void;
}

const CourseButton = ({ courseType, onChange }: Props) => {
  const button = useButton({
    onClick: () => {
      onChange(courseType);
    },
  });

  return (
    <Type {...button} color={courseType.color}>
      <Heading level={4} bottom={4}>
        {courseType.label}
      </Heading>
      {courseType.name && (
        <Heading level={7} color={'var(--colorBlueGray1300)'}>
          {courseType.name}
        </Heading>
      )}
    </Type>
  );
};

export default CourseButton;
